import { render, staticRenderFns } from "./ReferenceX1.vue?vue&type=template&id=17296d0b&scoped=true&"
import script from "./ReferenceX1.vue?vue&type=script&lang=ts&"
export * from "./ReferenceX1.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceX1.vue?vue&type=style&index=0&id=17296d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17296d0b",
  null
  
)

export default component.exports